import {
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export default function AutoDriverDispatch(props) {
  return (
    <div>
      <Typography>Auto Driver Dispatch</Typography>
      <Divider />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button variant="contained" size="small">
          Add Driver
        </Button>
        <Button variant="contained" size="small">
          Remove
        </Button>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Driver</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {/* <TableCell>City</TableCell> */}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
